import React from 'react';
import styles from './AlmostThereModal.module.css';

/**
 * In-progress motivation pop-up — shown every time the subject page opens
 * while a chapter is started-but-unfinished. Feel-good, dopamine-rich copy +
 * per-type remaining counts + badge teaser.
 *
 * items: [{ title, remaining, pct, lecsRemaining, dppsRemaining, testsRemaining }]
 */
const AlmostThereModal = ({ items, subjectLabel, hue = '#6366f1', hue2 = '#4338ca', onClose }) => {
  if (!items || items.length === 0) return null;
  const chapters = items.slice(0, 3);
  const closest = chapters[0]; // fewest remaining
  const oneLeft = closest.remaining === 1;

  return (
    <div className={styles.overlay} role="dialog" aria-modal="true" aria-label="Keep going">
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        <div className={styles.glowBar} style={{ background: `linear-gradient(90deg, ${hue}, ${hue2})` }} />
        <button type="button" className={styles.closeBtn} onClick={onClose} aria-label="Close">✕</button>

        {/* confetti bursts */}
        <span className={`${styles.confetti} ${styles.c1}`}>🎉</span>
        <span className={`${styles.confetti} ${styles.c2}`}>✨</span>
        <span className={`${styles.confetti} ${styles.c3}`}>🏅</span>
        <span className={`${styles.confetti} ${styles.c4}`}>⭐</span>

        <div className={styles.body}>
          <div className={styles.flameWrap}>
            <span className={styles.flame}>🔥</span>
          </div>
          <p className={styles.kicker}>You're on a roll</p>
          <h3 className={styles.heading}>
            {oneLeft ? 'Just ONE step from glory!' : "You're so close to a badge!"}
          </h3>
          <p className={styles.text}>
            {oneLeft
              ? <>Only <strong>1 item</strong> stands between you and the <strong>{closest.title}</strong> badge. You've got this! 💪</>
              : <>You've already started <strong>{subjectLabel}</strong> — champions finish what they start. A shiny <strong>badge</strong> is waiting on your profile! 🏅</>}
          </p>

          <div className={styles.chapterList}>
            {chapters.map((c) => (
              <div key={c.chapterId} className={styles.chapterCard}>
                <div className={styles.chapterHead}>
                  <span className={styles.chapterTitle}>{c.title}</span>
                  <span className={styles.chapterPct} style={{ color: hue }}>{c.pct}%</span>
                </div>
                <div className={styles.progressTrack}>
                  <div className={styles.progressFill} style={{ width: `${c.pct}%`, background: `linear-gradient(90deg, ${hue}, ${hue2})` }} />
                </div>
                <div className={styles.remainingRow}>
                  {c.lecsRemaining > 0 && <span className={styles.remChip}>🎬 {c.lecsRemaining} lecture{c.lecsRemaining > 1 ? 's' : ''}</span>}
                  {c.dppsRemaining > 0 && <span className={styles.remChip}>📝 {c.dppsRemaining} DPP{c.dppsRemaining > 1 ? 's' : ''}</span>}
                  {c.testsRemaining > 0 && <span className={styles.remChip}>✍️ {c.testsRemaining} test{c.testsRemaining > 1 ? 's' : ''}</span>}
                  <span className={styles.remChipLeft}>🏅 {c.remaining} to badge</span>
                </div>
              </div>
            ))}
          </div>

          <button
            type="button"
            className={styles.ctaBtn}
            style={{ background: `linear-gradient(135deg, ${hue}, ${hue2})` }}
            onClick={onClose}
          >
            Let's Finish It 🚀
          </button>
          <p className={styles.note}>Every item you complete is progress your future rank will thank you for.</p>
        </div>
      </div>
    </div>
  );
};

export default AlmostThereModal;
